import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../login.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as myGlobal from '../../../global';
import { CookieService } from 'ngx-cookie-service';

@Component( {
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
} )
export class LoginComponent implements OnInit {

    signInForm: FormGroup;
    submitted = false;
    errMsg: string;
    failMsg: string;
    cookieValue = 'UNKNOWN';
    username = 'amitk';
    password = 'Empower@123';
    statusObj: any;
    verifyUser = new FormGroup( {
        userN: new FormControl( '', [Validators.required] ),
        OTP: new FormControl( '', [Validators.required] ),
    } );
    userNReq;
    OTPReq;
    userNVer = false;
    userNErrVer = false;
    user_ver_msg;
    otp_err_req;
    sub;
    loginClass = {
        'username': [
            {'success-validate': false, 'error-validate': false},
            {'icon-work-done': false, 'icon-close-border': false}
        ],
        'password': [
            {'success-validate': false, 'error-validate': false},
            {'icon-work-done': false, 'icon-close-border': false}
        ]
    };
    isusernameReq = false;
    usr_err_req;
    ispasswordReq = false;
    password_err_req;
    otpClass = {
        'userN': [
            {'success-validate': false, 'error-validate': false},
            {'icon-work-done': false, 'icon-close-border': false}
        ],
        'OTP': [
            {'success-validate': false, 'error-validate': false},
            {'icon-work-done': false, 'icon-close-border': false}
        ]
    };
    isuserReq = false;
    user_err_req;
    isotpReq = false;
    verifyotp_err_req;

    constructor( private cookieService: CookieService, private fb: FormBuilder, private loginService: LoginService,
                 private route: ActivatedRoute, private router: Router ) {

    }

    get f() {
        return this.signInForm.controls;
    }

    clearverifyOTP() {
        this.verifyUser.reset();
        this.userNVer = false;
        this.userNErrVer = false;
    }

    verifyOTP() {

        const userVeriftobj = {
            'username': this.verifyUser.get( 'userN' ).value,
            'verification_code': this.verifyUser.get( 'OTP' ).value
        };
        if ( this.verifyUser.get( 'userN' ).valid ) {
            this.userNVer = false;
            this.userNErrVer = false;
            if ( this.sub ) {
                this.sub.unsubscribe();
            }
            this.sub = this.loginService.postuserVerify( userVeriftobj )
                .subscribe( post => {
                    if ( this.sub ) {
                        this.sub.unsubscribe();
                    }

                    this.userNVer = true;
                    this.userNErrVer = false;
                    this.user_ver_msg = 'Success';
                    this.verifyUser.reset();
                }, error => {
                    this.userNErrVer = false;
                    this.userNErrVer = true;
                    this.user_ver_msg = error.error.error_msg;
                    this.verifyUser.reset();
                } );
        }
    }

    ngOnInit() {
        this.signInForm = this.fb.group( {
            username: ['', Validators.required],
            password: ['', Validators.required]
        } );
    }

    onEnterUsername() {
        if ( this.signInForm.get( 'username' ).valid ) {
            this.isusernameReq = false;
            this.loginClass[ 'username' ] = [
                {'success-validate': true, 'error-validate': false},
                {'icon-work-done': true, 'icon-close-border': false},
            ];
        } else if ( this.signInForm.get( 'username' ).hasError( 'required' ) ) {
            this.isusernameReq = true;
            this.usr_err_req = myGlobal.USER_EMAIL_ERR_REQ;
            this.loginClass[ 'username' ] = [
                {'success-validate': false, 'error-validate': true},
            ];
        }
    }

    onEnterPassword() {
        if ( this.signInForm.get( 'password' ).valid ) {
            this.ispasswordReq = false;
            this.loginClass[ 'password' ] = [
                {'success-validate': true, 'error-validate': false},
            ];
        } else if ( this.signInForm.get( 'password' ).hasError( 'required' ) ) {
            this.ispasswordReq = true;
            this.password_err_req = myGlobal.PASSWORD_ERR_REQ;
            this.loginClass[ 'password' ] = [
                {'success-validate': false, 'error-validate': true},
            ];
        }
    }

    onVerifyUsername() {
        if ( this.verifyUser.get( 'userN' ).valid ) {
            this.isuserReq = false;
            this.otpClass[ 'userN' ] = [
                {'success-validate': true, 'error-validate': false},
                {'icon-work-done': true, 'icon-close-border': false},
            ];
        } else if ( this.verifyUser.get( 'userN' ).hasError( 'required' ) ) {
            this.isuserReq = true;
            this.user_err_req = myGlobal.USER_EMAIL_ERR_REQ;
            this.otpClass[ 'userN' ] = [
                {'success-validate': false, 'error-validate': true},
            ];
        }
    }

    onEnterOtp() {
        if ( this.verifyUser.get( 'OTP' ).valid ) {
            this.isotpReq = false;
            this.otpClass[ 'OTP' ] = [
                {'success-validate': true, 'error-validate': false},
            ];
        } else if ( this.verifyUser.get( 'OTP' ).hasError( 'required' ) ) {
            this.isotpReq = true;
            this.verifyotp_err_req = myGlobal.OTP_ERR_REQ;
            this.otpClass[ 'OTP' ] = [
                {'success-validate': false, 'error-validate': true},
            ];
        }
    }

    postSignIn() {
        const postJson = {'username': this.signInForm.value.username, 'password': this.signInForm.value.password};
        const myJson = JSON.stringify( postJson );

        this.loginService.postSignIn( postJson ).subscribe( post => {
                // console.log(post)
                for ( let i in post ) {
                    this.cookieService.set( 'Token', post[ 'id_token' ] );
                    this.cookieService.set( 'userId', post[ 'user_id' ] );
                    this.cookieService.set( 'username', post[ 'username' ] );
                }
                this.cookieService.set( 'Provider', 'COGNITO' );
                this.router.navigate( ['dashboard'] );
            }
            , error => {
                this.errMsg = error.error.error_msg;
            } );
    }

    onSubmit() {
        this.submitted = true;
        if ( this.signInForm.invalid ) {
            return;
        }
    }
}
